const a = [
  "aria-brailleroledescription",
  "aria-roledescription",
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-hidden",
  "aria-disabled",
  "aria-expanded",
  "aria-haspopup",
  "aria-relevant"
], r = ["aria-live", "aria-atomic", "aria-busy", ...a], n = ["aria-pressed", "aria-controls", ...a], i = ["aria-checked", "aria-invalid", "aria-errormessage", "aria-readonly", "aria-controls", ...a], l = ["aria-invalid", ...a], t = [
  "aria-required",
  "aria-readonly",
  "aria-placeholder",
  "aria-invalid",
  "aria-errormessage",
  "aria-autocomplete",
  "aria-controls",
  ...a
], s = ["aria-multiselectable", "aria-selected", "aria-expanded", "aria-haspopup", ...t, ...a], c = ["aria-modal", ...a], d = ["aria-current", "aria-disabled", "aria-label", ...a], u = ["aria-multiselectable", "aria-activedescendant", ...a], b = ["aria-level", "aria-posinset", "aria-setsize", ...a], m = ["aria-selected", ...a], p = ["aria-valuetext", "aria-valuenow", "aria-valuemin", "aria-valuemax", ...r, ...a], g = ["aria-checked", "aria-invalid", "aria-errormessage", "aria-controls", ...a], h = ["aria-selected", "aria-controls", ...a], o = ["aria-level", ...a], v = ["aria-rowcount", "aria-colcount", "aria-labelledby", "aria-describedby", ...a], x = ["aria-orientation", "aria-activedescendant", ...a], f = {
  alert: r,
  button: n,
  checkbox: i,
  combobox: s,
  dialog: c,
  textbox: t,
  link: d,
  listbox: u,
  listitem: b,
  option: m,
  progressbar: p,
  radio: i,
  radiogroup: l,
  switch: g,
  tab: h,
  tabpanel: a,
  heading: o,
  table: v,
  img: o,
  region: a,
  menu: x
}, k = {
  button: "button",
  a: "link",
  div: "region",
  input: "textbox",
  img: "img",
  form: "form",
  header: "banner",
  footer: "contentinfo",
  nav: "navigation",
  section: "region",
  article: "article",
  aside: "complementary",
  main: "main",
  table: "table",
  tr: "row",
  th: "columnheader",
  td: "cell",
  ul: "list",
  ol: "list",
  li: "listitem",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  progress: "progressbar",
  textarea: "textbox",
  select: "listbox",
  option: "option",
  dialog: "dialog",
  figure: "figure",
  figcaption: "figcaption",
  blockquote: "blockquote",
  time: "time",
  mark: "mark",
  meter: "meter",
  output: "output",
  summary: "summary",
  details: "details",
  abbr: "abbr",
  address: "address",
  b: "strong",
  i: "em",
  code: "code",
  pre: "pre",
  small: "small",
  sub: "sub",
  sup: "sup",
  var: "var",
  wbr: "wbr",
  canvas: "img",
  audio: "audio",
  video: "video",
  source: "source",
  track: "track",
  map: "map",
  area: "link",
  iframe: "document",
  embed: "embed",
  object: "object",
  picture: "img",
  template: "template",
  slot: "slot",
  del: "deletion",
  ins: "insertion",
  caption: "caption",
  col: "column",
  colgroup: "column",
  thead: "rowgroup",
  tbody: "rowgroup",
  tfoot: "rowgroup",
  fieldset: "group",
  legend: "legend",
  label: "label",
  datalist: "listbox",
  optgroup: "group",
  menu: "menu"
}, w = (e) => {
  if (e)
    return "current" in e ? w(e.current) : e;
}, y = (e) => typeof window < "u" ? e in window : !1, T = !!(typeof window < "u" && window.document && window.document.createElement);
export {
  f as R,
  k as T,
  T as a,
  w as g,
  y as i
};
